import { apiPost } from "../api/api";

export const exceptionHandler = (ex, message, errorDetail = {}) => {
    // Create the error message
    const jsonObject = {
        "Error Message": message || ex?.message || "",
        "Error Details": errorDetail,
        "Error Object": ex,
        "URL href": window?.location?.href || "---",
        "URL pathname": window?.location?.pathname || "---",
        "Previous URL 1": document?.referrer || "---",
        "Previous URL 2": window?.history?.previous?.href || "---",
        "Previous URL 3": window?.history?.state?.prevUrl || "---",
    }

    // Sending Email
    console.error("Exception Handler:", jsonObject);
    try { apiPost("/reviews/exception", jsonObject); }
    catch (ex) { console.log("Error sending exception", ex) }
}